import { Controller } from "stimulus";

export default class extends Controller {
  view(event) {
    const src = event.currentTarget.getAttribute("data-webcam-src");
    const modal = document.getElementById("webcam-viewer");
    const iframe = modal.querySelector("iframe");

    const title = event.currentTarget.getAttribute("data-webcam-title");

    iframe.setAttribute("src", src);
    modal.querySelector(".js-webcam-title").textContent = title;
    $(modal).modal();
  }

  disconnect() {
    const modal = document.getElementById("webcam-viewer");
    const iframe = modal.querySelector("iframe");

    iframe.setAttribute("src", "");
  }
}
